const environment = () => {
  const { hostname } = typeof window !== 'undefined' && window.location;
  switch (hostname) {
    case 'auth.fairprice.com.sg':
      return 'production';
    case 'preprod-auth.fairprice.com.sg':
      return 'preproduction';
    default:
      return undefined;
  }
};

export default {
  name: environment,
  datadogAPIKey: () => {
    switch (environment()) {
      case 'production':
        return '8afa97d3-fbc3-41a0-acaa-cb7aa3ac7132';
      case 'preproduction':
        return '46130004-93c3-4ac5-96ad-c9922f4e25d4';
      default:
        return '';
    }
  },
  datadogClientToken: () => {
    switch (environment()) {
      case 'production':
        return 'pubc09d8584cbb3c6caf5e22932c790f5bd';
      case 'preproduction':
        return 'pubfc92204936ba1aa680a25203fa7aecf9';
      default:
        return '';
    }
  },
  // realm: (clientId) => {
  //   switch (environment()) {
  //     case 'production':
  //       return clientId === process.env.DAE_CLIENT_ID_PROD
  //         ? process.env.DAE_REALM
  //         : process.env.DEFAULT_REALM;
  //     case 'preproduction':
  //       return clientId === process.env.DAE_CLIENT_ID_PREPROD
  //         ? process.env.DAE_REALM
  //         : process.env.DEFAULT_REALM;
  //     default:
  //       return clientId === process.env.DAE_CLIENT_ID_PREPROD
  //         ? process.env.DAE_REALM
  //         : process.env.DEFAULT_REALM;
  //   }
  // },
  realm: (clientId) => {
    switch (environment()) {
      case 'production':
        return clientId === 'jmqCiK3RJFP5K0DBVlPwvI4611eea5TS'
          ? 'NE-Digital-ID-Helpdesk-Connection'
          : 'NE-Digital-ID-Platform-Connection';
      case 'preproduction':
        return clientId === 'oSwpca8DoZmc47cJejFk8gnIh39ZyLdZ'
          ? 'NE-Digital-ID-Helpdesk-Connection'
          : 'NE-Digital-ID-Platform-Connection';
      default:
        return clientId === 'oSwpca8DoZmc47cJejFk8gnIh39ZyLdZ'
          ? 'NE-Digital-ID-Helpdesk-Connection'
          : 'NE-Digital-ID-Platform-Connection';
    }
  },
};
